import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { formulariosService } from '../services/api'

export default function FormularioCotizacionMantenimiento() {
  const { ticketId } = useParams()
  const [ticket, setTicket] = useState(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [form, setForm] = useState({
    numeroEquipos: '',
    ubicaciones: '',
    marcaModelo: '',
    antiguedad: '',
    tieneRegistro: false,
    tipoServicio: 'correctivo',
    notas: ''
  })

  useEffect(() => {
    formulariosService.obtenerTicket(ticketId)
      .then(r => setTicket(r.data))
      .catch(() => setError(true))
      .finally(() => setCargando(false))
  }, [ticketId])

  const enviar = async () => {
    setEnviando(true)
    try {
      await formulariosService.cotizacionMantenimiento(ticketId, form)
      setEnviado(true)
    } catch (err) {
      setError(true)
    } finally {
      setEnviando(false)
    }
  }

  const contenedorStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F1EFE8', padding: 20 }
  const cardStyle = { background: '#fff', borderRadius: 12, padding: 32, maxWidth: 480, width: '100%', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }

  if (cargando) {
    return <div style={contenedorStyle}><div>Cargando...</div></div>
  }

  if (error && !ticket) {
    return (
      <div style={contenedorStyle}>
        <div style={cardStyle}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 12 }}>Enlace no válido</div>
          <div style={{ fontSize: 14, color: '#8A8A7A' }}>No pudimos encontrar tu solicitud. Por favor contacta directamente a atencion@districtcoolingarboleda.com.</div>
        </div>
      </div>
    )
  }

  if (enviado) {
    return (
      <div style={contenedorStyle}>
        <div style={cardStyle}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 12 }}>¡Gracias!</div>
          <div style={{ fontSize: 14, color: '#8A8A7A' }}>Recibimos la información de tus equipos. Condo Care (Tel: 8110307266, admin@condocare.mx) se pondrá en contacto contigo para la cotización.</div>
        </div>
      </div>
    )
  }

  return (
    <div style={contenedorStyle}>
      <div style={cardStyle}>
        <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 4 }}>Cotización de mantenimiento</div>
        <div style={{ fontSize: 13, color: '#8A8A7A', marginBottom: 20 }}>
          {ticket?.locatario?.nombre} · {ticket?.locatario?.subscriptionExternalId}
        </div>

        <div className="form-group">
          <label className="form-label">Número de equipos</label>
          <input className="form-input" type="number" min="1" value={form.numeroEquipos} onChange={e => setForm({ ...form, numeroEquipos: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Ubicación de los equipos</label>
          <textarea className="form-input" style={{ height: 60, resize: 'none' }} placeholder="Ej. Fan coil sala, fan coil recámara principal..." value={form.ubicaciones} onChange={e => setForm({ ...form, ubicaciones: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Marca / modelo (si lo sabes)</label>
          <input className="form-input" value={form.marcaModelo} onChange={e => setForm({ ...form, marcaModelo: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Antigüedad aproximada</label>
          <input className="form-input" placeholder="Ej. 2 años" value={form.antiguedad} onChange={e => setForm({ ...form, antiguedad: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Tipo de servicio</label>
          <select className="form-input" value={form.tipoServicio} onChange={e => setForm({ ...form, tipoServicio: e.target.value })}>
            <option value="correctivo">Correctivo (algo está fallando)</option>
            <option value="preventivo">Preventivo / mantenimiento regular</option>
            <option value="instalacion">Instalación nueva</option>
          </select>
        </div>
        <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" id="tieneRegistro" checked={form.tieneRegistro} onChange={e => setForm({ ...form, tieneRegistro: e.target.checked })} />
          <label htmlFor="tieneRegistro" className="form-label" style={{ marginBottom: 0 }}>Ya cuento con registro de servicio previo</label>
        </div>
        <div className="form-group">
          <label className="form-label">Notas adicionales</label>
          <textarea className="form-input" style={{ height: 60, resize: 'none' }} value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} />
        </div>

        <button className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} onClick={enviar} disabled={enviando}>
          {enviando ? 'Enviando...' : 'Enviar solicitud'}
        </button>
        <div style={{ fontSize: 11, color: '#8A8A7A', marginTop: 12, textAlign: 'center' }}>
          Condo Care (Tel: 8110307266, admin@condocare.mx) te contactará con la cotización.
        </div>
      </div>
    </div>
  )
}
